// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:19
import { ZoneAggregation_abstract } from './../abstract/SagaBase/ZoneAggregation_abstract';
export class ZoneAggregation extends ZoneAggregation_abstract {}
